import { useCallback, useEffect, useState } from "react";
import { api } from "../lib/api";

/** Boleh-tidaknya akun ini memakai tombol "Lengkapi No HP" nota lama (jawaban
 *  owner 24 Sep 2026, pertanyaan 29b: "hanya SPV dan jabatan ke atas").
 *
 *  Gerbangnya JABATAN karyawan, dan jabatan tidak ada di payload login — jadi
 *  layar tidak menebak dari role/izin (tebakan meleset = tombol yang berujung
 *  403, aturan #3), melainkan bertanya ke server: `GET /retur/wewenang-saya`
 *  dihitung fungsi yang SAMA dengan gerbang endpoint lengkapi-no-hp. Dipakai
 *  HANYA oleh `components/retur/GerbangLengkapiNoHp` (satu sumber untuk dua layar).
 *
 *  `kunci` (id nota) ikut memicu tanya ulang: mengganti nota adalah langkah
 *  pemulihan yang wajar setelah jaringan putus.
 *
 *  -> { boleh: null (sedang bertanya) | true | false | "galat", ulangi }.
 *     "galat" SENGAJA dibedakan dari false: kalau galat dibaca "tidak boleh",
 *     SPV sungguhan disuruh "minta SPV" dan formnya terkunci sampai modal
 *     ditutup — ditolak dengan pesan yang masuk akal, jenis cacat yang paling
 *     lama ketahuan (CLAUDE.md, "Mulai istirahat"). */
export default function useBolehLengkapiNoHp(kunci) {
  const [boleh, setBoleh] = useState(null);
  const [putaran, setPutaran] = useState(0);
  useEffect(() => {
    let batal = false;
    setBoleh(null);
    api.get("/retur/wewenang-saya")
      .then(r => { if (!batal) setBoleh(r?.data?.lengkapi_no_hp === true); })
      .catch(() => { if (!batal) setBoleh("galat"); });
    return () => { batal = true; };
  }, [kunci, putaran]);
  const ulangi = useCallback(() => setPutaran(n => n + 1), []);
  return { boleh, ulangi };
}
